var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_vm._t("default",function(){return [_c('v-btn',{attrs:{"text":"","color":"accent-4 border__aaa"},on:{"click":_vm.onAssignWithInformationClicked}},[_vm._v(" "+_vm._s(_vm._f("translate")('배정취소'))+" ")])]},null,{ on: _vm.on })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }